import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CaretDown } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";

const OPTIONS = ["USD", "EUR", "GBP", "JPY", "CNY", "INR", "AED", "SAR", "AUD", "CAD", "CHF", "TRY", "BRL", "IQD"];

export function BaseCurrencySelect() {
  const { user, refresh } = useAuth();
  const qc = useQueryClient();
  const [saving, setSaving] = useState(false);
  const base = user?.base_currency || "USD";

  const change = async (code) => {
    if (code === base) return;
    setSaving(true);
    try {
      await api.patch("/auth/preferences", { base_currency: code });
      await refresh();
      qc.invalidateQueries();
      toast.success(`Display currency set to ${code}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally { setSaving(false); }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="base-currency-trigger" disabled={saving}
          className="inline-flex h-9 items-center gap-1.5 border border-border bg-card px-3 hover-lift text-sm font-mono font-medium">
          {base} <CaretDown size={12} weight="bold" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-muted-foreground">Display Currency</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <div className="max-h-72 overflow-auto">
          {OPTIONS.map((c) => (
            <DropdownMenuItem key={c} onClick={() => change(c)} data-testid={`base-option-${c}`}
              className={`font-mono ${c === base ? "text-primary font-semibold" : ""}`}>
              {c}{c === base ? " ✓" : ""}
            </DropdownMenuItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
